import axios from "axios";
import { URL } from "./MainAPILink";
// import { notificationHandler } from "reducers/notificationSlice";
import CatchMessage from "./catchMessage";
import { notify } from "App";
const AddNewAlbum = async (data, access_token, dispatch) => {
  try {
    const response = await axios.post(URL + "media/album", data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    // notificationHandler("New Album Added", "success", dispatch);
    return response.data.data;
  } catch (err) {
    CatchMessage(err);
    notify(err.response?.message, "error");

    return null;
  }
};
const uploadAlbumMedia = async (data, access_token, dispatch) => {
  try {
    const response = await axios.post(URL + "media", data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });

    return response.data.data;
  } catch (err) {
    CatchMessage(err);
    notify(err.response?.message, "error");
    return null;
  }
};

const GetAlbumDetails = async (data, access_token, dispatch) => {
  try {
    const response = await axios.get(URL + "media?media_album_id=" + data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });

    return response.data.data;
  } catch (err) {
    CatchMessage(err);

    return null;
  }
};
const GetAllAlbums = async (access_token, dispatch) => {
  try {
    const response = await axios.get(URL + "media/album", {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });

    return response.data.data.list;
  } catch (err) {
    CatchMessage(err);
    return null;
  }
};
const DeleteAlbum = async (data, access_token, dispatch) => {
  try {
    const response = await axios.delete(URL + "media/album?media_album_id=" + data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    // notificationHandler("BLog Deleted !", "success", dispatch);
    notify("Album Deleted !", "success");

    return response.data;
  } catch (err) {
    CatchMessage(err);
    notify(err.response?.message, "error");

    return null;
  }
};
const DeleteMediaAPI = async (mediaId, access_token, dispatch) => {
  try {
    const response = await axios.delete(URL + "media/?media_id=" + mediaId, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    // notificationHandler("BLog Deleted !", "success", dispatch);
    notify("Media Deleted !", "success");

    return response.data;
  } catch (err) {
    CatchMessage(err);
    notify(err.response?.message, "error");

    return null;
  }
};
const EditAlbumAPI = async (data, access_token, dispatch) => {
  try {
    const response = await axios.put(URL + "media/album", data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    // notificationHandler("Album Edited", "success", dispatch);
    return response.data.data.data;
  } catch (err) {
    CatchMessage(err);
    notify(err.response?.message, "error");

    return null;
  }
};

export {
  AddNewAlbum,
  uploadAlbumMedia,
  GetAlbumDetails,
  GetAllAlbums,
  DeleteAlbum,
  EditAlbumAPI,
  DeleteMediaAPI,
};
